exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2fnmg7K1bwzvijdqx7lK6M .ms-OverflowSet-item{width:100%}html[dir] ._2fnmg7K1bwzvijdqx7lK6M .ms-OverflowSet{margin:0}html[dir] ._2fnmg7K1bwzvijdqx7lK6M .ms-CommandBar{padding:0}.yRcpxaIaoXIedGaa-X2Je{width:100%}html[dir] .yRcpxaIaoXIedGaa-X2Je{padding:10px 3px;border:solid 1px}html[dir=ltr] .yRcpxaIaoXIedGaa-X2Je{text-align:left}html[dir=rtl] .yRcpxaIaoXIedGaa-X2Je{text-align:right}", ""]);
// Exports
exports.locals = {
	"dropdownContainer": "_2fnmg7K1bwzvijdqx7lK6M",
	"commandBarButton": "yRcpxaIaoXIedGaa-X2Je"
};